import { i18nKeys } from '@/src/utils/i18n.utils';
import { Box, Button, Modal, SpaceBetween } from '@amzn/awsui-components-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface ChallengeNotCompleteProps {
  value: boolean;
  message?: string;
  setValue: React.Dispatch<React.SetStateAction<boolean>> | (() => void);
  'data-testid'?: string;
}

const ChallengeNotCompleteModal: React.FC<ChallengeNotCompleteProps> = ({ value, message, setValue, ...rest }) => {
  const { t } = useTranslation();
  const handleModal = () => setValue(!value);

  return (
    <Modal
      data-testid={rest['data-testid']}
      onDismiss={handleModal}
      visible={value}
      header={<Box variant="h4">{t(i18nKeys.myJams.challenges.details.task.modal.challengeNotComplete.title)}</Box>}
      footer={
        <Box float="right" margin={{ vertical: 'xs' }}>
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="primary" onClick={handleModal}>
              {t(i18nKeys.general.close)}
            </Button>
          </SpaceBetween>
        </Box>
      }
      disableContentPaddings
      closeAriaLabel={t(i18nKeys.general.closeModal)}
    >
      <Box className="not-complete-modal">
        <SpaceBetween direction="vertical" size="xxxs">
          <Box variant="p">
            {message || t(i18nKeys.myJams.challenges.details.task.modal.challengeNotComplete.subtitle)}
          </Box>
        </SpaceBetween>
        <img src="/assets/Mask group.png" width={200} alt="" />
      </Box>
    </Modal>
  );
};

export default ChallengeNotCompleteModal;
